// Copyright 2021 Sorama B.V.

import { autoinject, customElement, observable } from "aurelia-framework";
import { IGuidanceTopic } from "catalogs/GuidanceCatalog";
import { IWorkflowModuleCatalog } from "catalogs/IWorkflowModuleCatalog";
import { WorkflowModuleType } from "libraries/WorkflowFramework/Interfaces/IWorkflowModuleConfig";
import { ShellViewManager } from "modules/shell/App/ShellViewManager";
import { WorkflowModeService } from "services/WorkflowModes/WorkflowModeService";

@customElement("knowledge-dropdown")
@autoinject
export class KnowledgeDropdown {
    //#region Private Properties
    @observable
    protected selectedTopic: IGuidanceTopic;

    public knowledgeList: IGuidanceTopic[];
    //#endregion

    public get modules(): IGuidanceTopic[] {
        return <IGuidanceTopic[]>this.moduleCatalog.getWorkflowModules(WorkflowModuleType.Help);
    }

    constructor(
        private readonly moduleCatalog: IWorkflowModuleCatalog,
        private readonly shellviewManager: ShellViewManager,
        private readonly workflowModeService: WorkflowModeService
    ) {}

    public bind(): void {
        this.knowledgeList = Object.values(this.modules).filter(
            (article) =>
                !article.hidden &&
                (!article.relevantWorkflowModes ||
                    article.relevantWorkflowModes.includes(this.workflowModeService.selectedWorkflowMode))
        );
    }

    public selectedTopicChanged(topic: IGuidanceTopic): Promise<void> {
        return this.shellviewManager.closeRightSideBar().then(() => {
            return this.shellviewManager.openRightSideBarHelp(topic.name);
        });
    }
}
